import { getBackend } from '@service/router/getters';
import { getBaseUrlByBackend } from './getBaseUrlByBackend';

export const getBaseUrl = (backend: string | null = null) => {
    const backendCode = backend ? backend : getBackend();

    return getBaseUrlByBackend(backendCode);
}